import { render, staticRenderFns } from "./AdmissionLetterDialog.vue?vue&type=template&id=1892be36&"
import script from "./AdmissionLetterDialog.vue?vue&type=script&lang=js&"
export * from "./AdmissionLetterDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionLetterDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports